var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"dense":"","flat":""}},[_c('v-toolbar-title',[_vm._v("ステータスボード")]),_c('v-spacer'),_c('v-btn',{attrs:{"tile":"","small":"","color":"secondary"},on:{"click":_vm.create}},[_vm._v("新規作成")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }